let hideWidgetPages = [
  '/',
  '/pages/quiz',
  '/pages/quiz-products',
  '/pages/welleasy-quiz',
  '/pages/welleasy-quiz-product',
  '/account/register',
  '/pages/membership-2',
  '/cart'
];

function handleZendeskWidget() {
  if (window.zE) {
    if (hideWidgetPages.includes(window.location.pathname)) {
      zE('messenger', 'close');
      zE('messenger', 'hide');
    } else {
      zE('messenger', 'show');
    }
  }
}

// Run on initial load
handleZendeskWidget();

// Ensure Zendesk widget is handled on every page load and navigation event
document.addEventListener('DOMContentLoaded', function () {
  handleZendeskWidget();
});
window.addEventListener('pageshow', function () {
  handleZendeskWidget();
});
// listen for URL changes to make sure widget is hidden or shown correctly
window.addEventListener('popstate', function () {
  handleZendeskWidget();
});

var customChatButton = document.getElementById("custom-chat-button");
if( customChatButton )
{
  customChatButton.addEventListener("click", function (e) {
    e.preventDefault();
    // Check if the Zendesk widget is loaded
    if (window.zE) {
      zE('messenger', 'open');
      zE('messenger', 'show');
    } else {
      console.warn("Zendesk widget is not loaded yet.");
    }

  });
}